export default __webpack_public_path__ + "static/media/landline.f5260dbd.svg";